import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import WageApprovalTab from '../settings/WageApprovalTab';

import BackButton from '../../components/common/BackButton';
export default function RateApprovalsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="mb-2">
            <BackButton fallbackTo={"/staffing/requests"} plainClassName="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Rate Approvals</h1>
          <p className="text-gray-600 mt-1">Review and approve staffing rate tiers before new request submissions.</p>
        </div>
      </div>

      <WageApprovalTab />
    </div>
  );
}
